import { useParams } from "react-router-dom";
import React from "react";

export const useParticipantFromUrl = () => {
  const { participantId } = useParams();
  const registrationId = React.useMemo(
    () => (participantId ? parseInt(participantId) : null),
    [participantId]
  );

  return registrationId;
};
